import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AssetModuleNavbar from "./AssetModuleNavbar";
import API_BASE_URL from "../config";

const Section = ({ title, children }) => {
  const [open, setOpen] = useState(true);
  return (
    <div className="mb-3 border">
      <div className="fw-bold p-2 border-bottom d-flex justify-content-between align-items-center"
        style={{ cursor: "pointer", backgroundColor: "#DFE4EB" }}
        onClick={() => setOpen(!open)}>
        <span>{title}</span><span>{open ? "▾" : "▸"}</span>
      </div>
      {open && <div className="row g-3 p-3">{children}</div>}
    </div>
  );
};

const ALLOCATION_TYPES = ["Permanent", "Temporary", "Project-based"];
const CONDITION_OPTIONS = ["New", "Good", "Fair", "Damaged"];

const initialForm = {
  allocationType: "Permanent",
  allocationDate: new Date().toISOString().split("T")[0],
  expectedReturnDate: "",
  conditionAtIssue: "New",
  handoverRemarks: "",
};

function OtpModal({ allocationId, employeeEmail, token, onClose, onSuccess }) {
  const [otpValue, setOtpValue] = useState("");
  const [otpError, setOtpError] = useState("");
  const [verifying, setVerifying] = useState(false);
  const [resending, setResending] = useState(false);

  const handleVerify = async () => {
    if (!otpValue.trim()) { setOtpError("Please enter the OTP."); return; }
    setVerifying(true); setOtpError("");
    try {
      const res = await fetch(`${API_BASE_URL}/api/asset-allocations/${allocationId}/verify-otp`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ otp: otpValue.trim() }),
      });
      const data = await res.json();
      if (!res.ok) { setOtpError(data.error || "Invalid OTP."); return; }
      toast.success("Acknowledgment confirmed! Asset handover complete.");
      onSuccess();
    } catch { setOtpError("Verification failed. Please try again."); }
    finally { setVerifying(false); }
  };

  const handleResend = async () => {
    setResending(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/asset-allocations/${allocationId}/resend-otp`, {
        method: "POST", headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) { toast.error("Failed to resend OTP."); return; }
      toast.info("OTP resent to employee's email.");
      setOtpValue(""); setOtpError("");
    } catch { toast.error("Failed to resend OTP."); }
    finally { setResending(false); }
  };

  return (
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1050, backdropFilter: "blur(2px)" }} />
      <div role="dialog" style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%,-50%)", zIndex: 1060, width: "min(420px,90vw)", background: "#fff", borderRadius: 12, boxShadow: "0 20px 60px rgba(0,0,0,0.25)", overflow: "hidden" }}>
        <div style={{ height: 4, background: "linear-gradient(90deg,#1e3a5f,#2d5a9e)" }} />
        <div style={{ padding: "28px 28px 24px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
            <div style={{ width: 44, height: 44, borderRadius: 10, background: "#eef2ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>🔐</div>
            <div>
              <h5 style={{ margin: 0, fontWeight: 700, fontSize: 16 }}>Acknowledge Asset Handover</h5>
              <p style={{ margin: "3px 0 0", fontSize: 13, color: "#6b7280" }}>OTP sent to <strong>{employeeEmail || "employee's email"}</strong></p>
            </div>
          </div>
          <div style={{ background: "#f0f4fa", borderRadius: 8, padding: "10px 14px", fontSize: 13, color: "#374151", marginBottom: 20, lineHeight: 1.6 }}>
            Ask the employee to check their email and provide the 6-digit OTP to confirm receipt.
          </div>
          <label style={{ fontSize: 13, fontWeight: 600, display: "block", marginBottom: 6 }}>Enter OTP <span style={{ color: "#dc3545" }}>*</span></label>
          <input type="text" inputMode="numeric" maxLength={6} value={otpValue}
            onChange={e => { setOtpValue(e.target.value.replace(/\D/g, "")); setOtpError(""); }}
            onKeyDown={e => e.key === "Enter" && handleVerify()}
            placeholder="6-digit OTP" autoFocus
            style={{ width: "100%", padding: "10px 14px", fontSize: 22, fontWeight: 700, letterSpacing: 8, textAlign: "center", border: `2px solid ${otpError ? "#dc3545" : "#d1d5db"}`, borderRadius: 8, outline: "none", boxSizing: "border-box" }} />
          {otpError && <p style={{ margin: "6px 0 0", fontSize: 13, color: "#dc3545" }}>{otpError}</p>}
          <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
            <button onClick={handleVerify} disabled={verifying || otpValue.length !== 6}
              style={{ flex: 1, padding: "10px", background: "#1e3a5f", color: "#fff", border: "none", borderRadius: 8, fontWeight: 600, fontSize: 14, cursor: otpValue.length !== 6 ? "not-allowed" : "pointer", opacity: otpValue.length !== 6 ? 0.6 : 1 }}>
              {verifying ? "Verifying..." : "Confirm Acknowledgment"}
            </button>
            <button onClick={onClose} style={{ padding: "10px 16px", background: "#f3f4f6", color: "#374151", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 14, cursor: "pointer" }}>Skip</button>
          </div>
          <p style={{ textAlign: "center", marginTop: 14, fontSize: 13, color: "#6b7280" }}>
            Didn't receive?{" "}
            <button onClick={handleResend} disabled={resending}
              style={{ background: "none", border: "none", color: "#2d5a9e", fontWeight: 600, cursor: "pointer", padding: 0, fontSize: 13 }}>
              {resending ? "Sending..." : "Resend OTP"}
            </button>
          </p>
        </div>
      </div>
    </>
  );
}

export default function NewAllocation() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [formData, setFormData] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const [allEmployees, setAllEmployees] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [employeeSearch, setEmployeeSearch] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showEmpDrop, setShowEmpDrop] = useState(false);

  const [allAvailableAssets, setAllAvailableAssets] = useState([]);
  const [availableAssets, setAvailableAssets] = useState([]);
  const [assetSearch, setAssetSearch] = useState("");
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [showAssetDrop, setShowAssetDrop] = useState(false);

  const [otpModal, setOtpModal] = useState(null);

  useEffect(() => {
    const bl = document.createElement("link"); bl.rel = "stylesheet"; bl.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"; document.head.appendChild(bl);
    const ic = document.createElement("link"); ic.rel = "stylesheet"; ic.href = "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css"; document.head.appendChild(ic);
    return () => { bl.remove(); ic.remove(); };
  }, []);

  useEffect(() => {
    const roles = JSON.parse(localStorage.getItem("roles") || "[]");
    if (!token) { toast.error("You must be logged in."); navigate("/"); return; }
    // if (!roles.includes("ROLE_ADMIN")) { toast.error("Unauthorized."); navigate("/"); }
  }, [navigate, token]);

  useEffect(() => {
    if (!token) return;
    fetch(`${API_BASE_URL}/api/employees/active`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => { const l = Array.isArray(d) ? d : d.content || []; setAllEmployees(l); setEmployees(l); })
      .catch(() => {});
  }, [token]);

  useEffect(() => {
    if (!token) return;
    fetch(`${API_BASE_URL}/api/assets?status=Available&size=200`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json()).then(d => { const l = d.content || []; setAllAvailableAssets(l); setAvailableAssets(l); })
      .catch(() => {});
  }, [token]);

  useEffect(() => {
    const q = employeeSearch.trim().toLowerCase();
    if (!q) { setEmployees(allEmployees); return; }
    setEmployees(allEmployees.filter(emp => {
      const name = emp.name || `${emp.firstName || ""} ${emp.lastName || ""}`.trim();
      return name.toLowerCase().includes(q) || (emp.employeeId || "").toLowerCase().includes(q) || (emp.departmentName || "").toLowerCase().includes(q);
    }));
  }, [employeeSearch, allEmployees]);

  useEffect(() => {
    const q = assetSearch.trim().toLowerCase();
    if (!q) { setAvailableAssets(allAvailableAssets); return; }
    setAvailableAssets(allAvailableAssets.filter(a =>
      (a.assetName || "").toLowerCase().includes(q) ||
      (a.assetCode || "").toLowerCase().includes(q) ||
      (a.serialNumber || "").toLowerCase().includes(q) ||
      (a.brand || "").toLowerCase().includes(q)
    ));
  }, [assetSearch, allAvailableAssets]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(p => ({ ...p, [name]: value }));
  };

  const validate = () => {
    const e = {};
    if (!selectedEmployee) e.employee = "Please select an employee.";
    if (!selectedAsset) e.asset = "Please select an asset.";
    if (!formData.allocationType) e.allocationType = "Allocation type is required.";
    if (!formData.allocationDate) e.allocationDate = "Allocation date is required.";
    if (formData.allocationType === "Temporary" && !formData.expectedReturnDate)
      e.expectedReturnDate = "Return date is required for temporary allocation.";
    return e;
  };

  const handleSubmit = async e => {
    e && e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) { setErrors(newErrors); toast.error("Please fix errors before submitting."); return; }
    try {
      setSubmitting(true);
      const res = await fetch(`${API_BASE_URL}/api/asset-allocations`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ employeeId: selectedEmployee.id, assetId: selectedAsset.id, ...formData }),
      });
      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      toast.success("Asset allocated! OTP sent to employee's email for acknowledgment.");
      setOtpModal({ allocationId: data.id, employeeEmail: selectedEmployee.email || "" });
      setFormData(initialForm);
      setSelectedEmployee(null); setSelectedAsset(null);
      setEmployeeSearch(""); setAssetSearch("");
      setErrors({});
    } catch (err) { toast.error(err.message || "Allocation failed."); }
    finally { setSubmitting(false); }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={4000} />
      <div className="fixed-top"><AssetModuleNavbar /></div>
      <div className="container-fluid my-4" style={{ paddingTop: "90px" }}>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h4 className="fw-bold mb-0"><i className="bi bi-person-plus me-2"></i> Asset Allocation</h4>
            <div className="d-flex gap-2">
            <button className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={submitting}>
              {submitting ? <><span className="spinner-border spinner-border-sm me-1"></span>Allocating...</> : <>Save </>}
            </button>
            <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)}>Cancel</button>
          </div>
            <div className="text-muted mt-1" style={{ fontSize: 13 }}>Assign an available asset to an employee with digital acknowledgment.</div>
          </div>
          <div className="d-flex gap-2">
            <a href="/allallocations" className="text-primary text-decoration-none me-3">
               List
            </a>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <Section title="Step 1 — Select Employee">
            <div className="col-md-4">
              <label className="form-label">Employee <span className="text-danger">*</span></label>
              <div className="position-relative">
                <input type="text" className={`form-control ${errors.employee ? "is-invalid" : ""}`}
                  placeholder="Click or type to search employees..."
                  value={employeeSearch}
                  onChange={e => { setEmployeeSearch(e.target.value); setShowEmpDrop(true); setSelectedEmployee(null); }}
                  onFocus={() => setShowEmpDrop(true)}
                  onBlur={() => setTimeout(() => setShowEmpDrop(false), 150)}
                  autoComplete="off" />
                {errors.employee && <div className="invalid-feedback">{errors.employee}</div>}
                {showEmpDrop && (
                  <div className="border bg-white position-absolute w-100 shadow" style={{ zIndex: 9999, maxHeight: 260, overflowY: "auto", top: "100%" }}>
                    {employees.length === 0 ? (
                      <div className="px-3 py-2 text-muted" style={{ fontSize: 13 }}>
                        {employeeSearch.trim() ? "No matching employees." : "No active employees found."}
                      </div>
                    ) : (
                      <>
                        <div className="px-3 py-1 border-bottom" style={{ fontSize: 11, color: "#6b7280", background: "#f9fafb" }}>
                          {employees.length} employee{employees.length !== 1 ? "s" : ""}{employeeSearch.trim() ? " matching" : ""}
                        </div>
                        {employees.map(emp => (
                          <div key={emp.id} className="px-3 py-2" style={{ cursor: "pointer", fontSize: 13 }}
                            onMouseDown={() => { setSelectedEmployee(emp); setEmployeeSearch(emp.name || `${emp.firstName} ${emp.lastName}`); setShowEmpDrop(false); }}
                            onMouseEnter={e => e.currentTarget.style.background = "#f5f6ff"}
                            onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                            <strong>{emp.name || `${emp.firstName} ${emp.lastName}`}</strong>
                            <small className="text-muted ms-2">{emp.employeeId} · {emp.department?.name || emp.departmentName}</small>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
            {selectedEmployee && (
              <>
                <div className="col-md-2">
                  <label className="form-label">Department</label>
                  <input className="form-control bg-light" readOnly value={selectedEmployee.department || "—"} />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Designation</label>
                  <input className="form-control bg-light" readOnly value={selectedEmployee.designation || "—"} />
                </div>
              </>
            )}
          </Section>

          <Section title="Step 2 — Select Asset">
            <div className="col-md-4">
              <label className="form-label">Asset (Available only) <span className="text-danger">*</span></label>
              <div className="position-relative">
                <input type="text" className={`form-control ${errors.asset ? "is-invalid" : ""}`}
                  placeholder="Click or type to search available assets..."
                  value={assetSearch}
                  onChange={e => { setAssetSearch(e.target.value); setShowAssetDrop(true); setSelectedAsset(null); }}
                  onFocus={() => setShowAssetDrop(true)}
                  onBlur={() => setTimeout(() => setShowAssetDrop(false), 150)}
                  autoComplete="off" />
                {errors.asset && <div className="invalid-feedback">{errors.asset}</div>}
                {showAssetDrop && (
                  <div className="border bg-white position-absolute w-100 shadow" style={{ zIndex: 9999, maxHeight: 260, overflowY: "auto", top: "100%" }}>
                    {availableAssets.length === 0 ? (
                      <div className="px-3 py-2 text-muted" style={{ fontSize: 13 }}>
                        {assetSearch.trim() ? "No matching available assets." : "No available assets found."}
                      </div>
                    ) : (
                      <>
                        <div className="px-3 py-1 border-bottom" style={{ fontSize: 11, color: "#6b7280", background: "#f9fafb" }}>
                          {availableAssets.length} available asset{availableAssets.length !== 1 ? "s" : ""}{assetSearch.trim() ? " matching" : ""}
                        </div>
                        {availableAssets.map(a => (
                          <div key={a.id} className="px-3 py-2" style={{ cursor: "pointer", fontSize: 13 }}
                            onMouseDown={() => { setSelectedAsset(a); setAssetSearch(`${a.assetCode} — ${a.assetName}`); setShowAssetDrop(false); }}
                            onMouseEnter={e => e.currentTarget.style.background = "#f5f6ff"}
                            onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                            <strong>{a.assetCode}</strong> — {a.assetName}
                            <small className="text-muted ms-2">{a.brand} · {a.subCategory}</small>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
            {selectedAsset && (
              <>
                <div className="col-md-2">
                  <label className="form-label">Category</label>
                  <input className="form-control bg-light" readOnly value={selectedAsset.category} />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Brand / Model</label>
                  <input className="form-control bg-light" readOnly value={`${selectedAsset.brand} ${selectedAsset.modelNumber}`} />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Serial No.</label>
                  <input className="form-control bg-light" readOnly value={selectedAsset.serialNumber} />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Location</label>
                  <input className="form-control bg-light" readOnly value={selectedAsset.location || "—"} />
                </div>
              </>
            )}
          </Section>

          <Section title="Step 3 — Allocation Details">
            <div className="col-md-3">
              <label className="form-label">Allocation Type <span className="text-danger">*</span></label>
              <select name="allocationType" className={`form-select ${errors.allocationType ? "is-invalid" : ""}`} value={formData.allocationType} onChange={handleChange}>
                {ALLOCATION_TYPES.map(o => <option key={o}>{o}</option>)}
              </select>
              {errors.allocationType && <div className="invalid-feedback">{errors.allocationType}</div>}
            </div>
            <div className="col-md-3">
              <label className="form-label">Allocation Date <span className="text-danger">*</span></label>
              <input type="date" name="allocationDate" className={`form-control ${errors.allocationDate ? "is-invalid" : ""}`} value={formData.allocationDate} onChange={handleChange} />
              {errors.allocationDate && <div className="invalid-feedback">{errors.allocationDate}</div>}
            </div>
            {formData.allocationType === "Temporary" && (
              <div className="col-md-3">
                <label className="form-label">Expected Return Date <span className="text-danger">*</span></label>
                <input type="date" name="expectedReturnDate" className={`form-control ${errors.expectedReturnDate ? "is-invalid" : ""}`} value={formData.expectedReturnDate} onChange={handleChange} min={formData.allocationDate} />
                {errors.expectedReturnDate && <div className="invalid-feedback">{errors.expectedReturnDate}</div>}
              </div>
            )}
            <div className="col-md-3">
              <label className="form-label">Asset Condition at Issue</label>
              <select name="conditionAtIssue" className="form-select" value={formData.conditionAtIssue} onChange={handleChange}>
                {CONDITION_OPTIONS.map(o => <option key={o}>{o}</option>)}
              </select>
            </div>
            <div className="col-md-12">
              <label className="form-label">Handover Remarks</label>
              <textarea name="handoverRemarks" className="form-control" value={formData.handoverRemarks} onChange={handleChange} rows={2} placeholder="Physical condition notes, accessories included..." maxLength={500} />
            </div>
            <div className="col-md-12">
              <div className="alert alert-info py-2 mb-0">
                <i className="bi bi-info-circle me-2"></i>
                Upon allocation, an email/OTP notification will be sent to <strong>{selectedEmployee?.name || "the employee"}</strong> for digital acknowledgment.
              </div>
            </div>
          </Section>

          <div className="d-flex gap-2 mt-3 mb-4">
            <button className="btn btn-primary" type="submit" disabled={submitting}>
              {submitting ? "Allocating..." : "Save "}
            </button>
            <button className="btn btn-secondary btn-sm" type="button" onClick={() => navigate(-1)}>Cancel</button>
          </div>
        </form>
      </div>

      {otpModal && (
        <OtpModal
          allocationId={otpModal.allocationId}
          employeeEmail={otpModal.employeeEmail}
          token={token}
          onClose={() => setOtpModal(null)}
          onSuccess={() => { setOtpModal(null); navigate("/allallocations"); }}
        />
      )}
    </>
  );
}
